import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { Page } from "~/components/Page";
import { LogDetails } from "./components/LogDetails";

export function LogPage() {
  return (
    <Page title="Log Details">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <LogDetails />
      </Container>
    </Page>
  );
}
